import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatDatetimepickerCalendarT2 } from "./calendar";
import { MatDatetimepickerCalendarBodyT2 } from "./calendar-body";
import { MatDatetimepickerT2, MatDatetimepickerContentT2 } from "./datetimepicker";
import { MatDatetimepickerInputT2 } from "./datetimepicker-input";
import { MatDatetimepickerToggleT2 } from "./datetimepicker-toggle";
import { MatDatetimepickerMonthViewT2 } from "./month-view";
import { MatDatetimepickerYearViewT2 } from "./year-view";
import { MatDatetimepickerMultiYearViewT2 } from "./multi-year-view";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatetimepickerClockT2 } from "./clock";
// import { MatDatetimepickerClockT2bootstrap } from "./clock-bootstrap";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
// import { MatTimepickerComponentT2 } from "./time-picker/timepicker.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        OverlayModule,
        A11yModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        MatFormFieldModule,
        MatInputModule
    ],
    declarations: [
        MatDatetimepickerCalendarT2,
        // MatTimepickerComponentT2,
        MatDatetimepickerCalendarBodyT2,
        // MatDatetimepickerClockT2bootstrap,
        MatDatetimepickerClockT2,
        MatDatetimepickerT2,
        MatDatetimepickerToggleT2,
        MatDatetimepickerInputT2,
        MatDatetimepickerContentT2,
        MatDatetimepickerMonthViewT2,
        MatDatetimepickerYearViewT2,
        MatDatetimepickerMultiYearViewT2
    ],
    exports: [
        MatDatetimepickerCalendarT2,
        // MatTimepickerComponentT2,
        MatDatetimepickerCalendarBodyT2,
        MatDatetimepickerClockT2,
        MatDatetimepickerT2,
        MatDatetimepickerToggleT2,
        MatDatetimepickerInputT2,
        MatDatetimepickerContentT2,
        MatDatetimepickerMonthViewT2,
        MatDatetimepickerYearViewT2,
        MatDatetimepickerMultiYearViewT2
    ]
})
export class MatDatetimepickerT2Module {
}
